<div class="block__right-side-panel">
    <div class="block-full-width no-padding no-border-radius">
        <div class="card-details">
            <div class="card-details-area">
                <h2 class="card-details-area__title" [ngClass]="{ 'margin-bottom-10': showRequiredText === true }">
                    {{ 'CARD_DETAILS_FORM_TITLE' | translate }}
                </h2>
                <p class="required-text" *ngIf="showRequiredText">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>

                <form [formGroup]="relatedCardForm" (ngSubmit)="submitCardForm()" ridangoFocusInvalidInput>
                    <div
                        class="card-details-area__card-category"
                        *ngIf="this.showCardTypes && this.allowedCardTypes && !this.isEditMode">
                        <ridango-dropdown-filter-wcag
                            class="card-dropdown"
                            [placeholder]="'CARD_TYPE'"
                            [items]="allowedCardTypes"
                            [filter]="selectedCardType?.name"
                            [selectedItem]="selectedCardType"
                            [required]="true"
                            (onItemSelected)="cardTypeSelected($event)">
                        </ridango-dropdown-filter-wcag>
                    </div>

                    <ng-container *ngIf="selectedCardType?.type === cardTypes.WALTTI_CARD">
                        <div class="margin-bottom-20 flex items-center">
                            <img
                                class="margin-right-10"
                                src="{{ assetsPath }}/waltti_card.png"
                                alt="{{ 'WALTTI_CARD_LABEL' | translate }}" />
                            <div>{{ 'WALTTI_CARD_DESCRIPTION' | translate }}</div>
                        </div>
                    </ng-container>

                    <div class="card-details-area__card-number">
                        <ridango-form-field class="form-margin-10">
                            <input
                                *ngIf="!this.selectedCardType?.displayPrefix"
                                [formControl]="relatedCardForm.controls.card_nr"
                                ridangoInput
                                value="{{ (selectedRelatedCard$ | async)?.card_nr }}"
                                name="travelcard.number"
                                required />

                            <input
                                *ngIf="this.selectedCardType?.displayPrefix"
                                [formControl]="relatedCardForm.controls.card_nr"
                                ridangoInput
                                ridangoPrefill="{{ this.selectedCardType?.prefix }}"
                                value="{{ (selectedRelatedCard$ | async)?.card_nr }}"
                                name="travelcard.number"
                                required />

                            <ridango-label>{{ 'PH_CARD_NUMBER' | translate }}</ridango-label>

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.card_nr.touched &&
                                    relatedCardForm.controls.card_nr.hasError('required')
                                ">
                                {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                            </ridango-error>

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.card_nr.touched &&
                                    relatedCardForm.controls.card_nr.hasError('pattern')
                                ">
                                {{ 'FIELD_VALIDATION_CARD_NUMBER_INVALID_FORMAT' | translate }}
                            </ridango-error>

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.card_nr.touched &&
                                    relatedCardForm.controls.card_nr.hasError('minlength')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                            </ridango-error>

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.card_nr.touched &&
                                    relatedCardForm.controls.card_nr.hasError('maxlength')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_MAX_LENGTH' | translate }}
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="card-details-area__card-name" *ngIf="environment.THEME_NAME === themeFeature.VL">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="relatedCardForm.controls.name"
                                ridangoInput
                                value="{{ (selectedRelatedCard$ | async)?.name }}"
                                name="travelcard.name"
                                aria-labelledby="nameCard" />
                            <ridango-label>{{ 'PH_CARD_NAME' | translate }}</ridango-label>

                            <ridango-hint class="input-description" id="nameCard">{{
                                'ADD_TRAVEL_CARD_NAME_HELPER' | translate
                            }}</ridango-hint>
                        </ridango-form-field>
                    </div>

                    <div class="card-details-area__card-pin" *ngIf="!hidePinField && !(editMode$ | async)">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="relatedCardForm.controls.card_pin"
                                ridangoInput
                                name="travelcard.pin"
                                required />
                            <ridango-label>{{ 'PH_CARD_PIN' | translate }}</ridango-label>

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.card_pin.touched &&
                                    relatedCardForm.controls.card_pin.hasError('required')
                                ">
                                {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                            </ridango-error>

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.card_pin.touched &&
                                    relatedCardForm.controls.card_pin.hasError('pattern')
                                ">
                                {{ 'FIELD_VALIDATION_CARD_NUMBER_INVALID_FORMAT' | translate }}
                            </ridango-error>

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.card_pin.touched &&
                                    relatedCardForm.controls.card_pin.hasError('minlength')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}</ridango-error
                            >

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.card_pin.touched &&
                                    relatedCardForm.controls.card_pin.hasError('maxlength')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_MAX_LENGTH' | translate }}</ridango-error
                            >
                        </ridango-form-field>
                    </div>

                    <div class="card-details-area__card-name" *ngIf="environment.THEME_NAME !== themeFeature.VL">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="relatedCardForm.controls.name"
                                ridangoInput
                                value="{{ (selectedRelatedCard$ | async)?.name }}"
                                name="travelcard.name"
                                aria-labelledby="nameCard"
                                required />
                            <ridango-label>{{ 'PH_CARD_NAME' | translate }}</ridango-label>

                            <ridango-error
                                *ngIf="
                                    relatedCardForm.controls.name.touched &&
                                    relatedCardForm.controls.name.hasError('required')
                                ">
                                {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                            </ridango-error>

                            <ridango-hint class="input-description" id="nameCard">{{
                                'ADD_TRAVEL_CARD_NAME_HELPER' | translate
                            }}</ridango-hint>
                        </ridango-form-field>
                    </div>

                    <div class="card-details-area__card-category" *ngIf="this.showDiscounts">
                        <mat-form-field class="full-width" *ngIf="this.showDiscounts" appearance="outline">
                            <mat-label>{{ 'RELATED_CARD_DETAIL_DISCOUNT' | translate }}</mat-label>
                            <!-- <mat-icon class="discount margin-right-10" matPrefix svgIcon="discount"></mat-icon> -->
                            <mat-select formControlName="groups">
                                <mat-option *ngFor="let option of allDiscounts" [value]="option.group_id">
                                    {{ option | translateObjectField: 'name' : locale }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__footer">
                        <div class="edit-profile-account-items-area__right">
                            <button
                                class="btn btn--maximal btn--primary btn--big"
                                *ngIf="!(editMode$ | async)"
                                [disabled]="relatedCardForm.invalid"
                                type="submit">
                                {{ 'BTN_CARD_DETAILS' | translate }}
                            </button>

                            <button
                                class="btn btn--maximal btn--primary btn--big"
                                *ngIf="editMode$ | async"
                                [disabled]="relatedCardForm.invalid"
                                type="submit">
                                {{ 'SAVE' | translate }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
